











import eventBus from '@/utils/eventBus';
import { Component, Vue } from 'vue-property-decorator';
import BillingGuidedTour from './BillingGuidedTour.vue';

@Component({
  components: {
    BillingGuidedTour
  }
})
export default class GuidedTours extends Vue {
  activedTour = '';

  startTour(name: string) {
    this.activedTour = name;
  }

  closeTour() {
    this.activedTour = '';
  }

  created() {
    eventBus.$on('startGuidedTour', this.startTour);
    eventBus.$on('closeGuidedTour', this.closeTour);
  }

  beforeDestroy() {
    eventBus.$off('startGuidedTour', this.startTour);
    eventBus.$off('closeGuidedTour', this.closeTour);
  }
}
